<template>
  <div class="van-page">
    <the-header title="日志管理" isShowArrow />
    <van-sticky>
      <van-search class="search-box" v-model="keyword" placeholder="项目名称" shape="round" />
    </van-sticky>
    <van-list class="van-container" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDataList">
      <div class="van-section" v-for="(item, index) in listData" :key="index">
        <div class="van-section__header">
          项目代码：{{ item.PROJECT_CODE }}
        </div>
        <div class="van-section__body">
          <div class="van-section__title">
            {{ item.PROJECT_NAME }}
          </div>
          <ul class="list-group">
            <li>
              <span>项目联系人：</span>
              <span>{{ item.LINK_MAN || '暂无数据' }}</span>
            </li>
            <li>
              <span>区划：</span>
              <span>{{ item.REGION_NAME || '暂无数据' }}</span>
            </li>
          </ul>
        </div>
        <div class="van-section__footer">
          <div class="footer-btn" @click="checkDetail(item)">查看详情</div>
          <div class="footer-btn" @click="editLog(item)">编辑日志</div>
        </div>
      </div>
    </van-list>
    <van-dialog v-model="show" title="日志详情" show-submit-button>
      <div class="log-content" v-html="logContent"></div>
    </van-dialog>
  </div>
</template>

<script>
import { getLogInfo, getContentInfo } from '@/api/interface/log'
export default {
  components: {
    'the-header': () => import('@/components/TheHeader')
  },
  data() {
    return {
      keyword: '',
      loading: false,
      pageNo: 1,
      finished: false,
      show: false,
      logContent: null,
      listData: []
    }
  },
  methods: {
    getDataList() {
      const user = this.$store.getters.getUser
      const instance = new getLogInfo({
        userId: user.postType == 'KY' ? user.userId : '',
        regionCode: user.postType == 'KZ' ? user.regionCode : '',
        page: this.pageNo++,
        rows: window.config.pageSize,
        projectName: this.keyword
      })
      instance
        .then((result) => {
          const data = JSON.parse(result.data.data).rows
          if (data.length > 0) {
            this.listData = this.listData.concat(data)
            this.loading = false
            if (data.length < window.config.pageSize) {
              this.finished = true
            } else {
              this.finished = false
            }
          } else {
            this.finished = true
            this.loading = false
          }
        }).catch((err) => {
          this.finished = true
          console.log(err);
        });
    },
    checkDetail(item) {
      
      this.$router.push({
        path: '/home/logDetail',
        query: {
          id: item.DC_ID,
          name: item.PROJECT_NAME,
        }})
    },
    editLog(item){
      this.$router.push({
        path: '/home/editLog',
        query: {
          id: item.DC_ID,
          name: item.PROJECT_NAME,
        }})
    }
  },
  watch: {
    keyword: {
      handler: _.debounce(function (newVal) {
        this.pageNo = 1
        this.listData = []
        this.getDataList()
      }, 500),
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.search-box {
  .van-search__content {
    border: 1px solid #EAEBEE;
    background: #fff;
  }
}

.van-container {
  padding: 12px 16px;
}

.van-section {
  background: #fff;
  margin-bottom: 12px;
  border-radius: 6px;
  position: relative;
}

.van-section__header {
  padding: 16px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 16px;
  height: 40px;
  background: linear-gradient(90deg, #DAE7FF 0%, #FFFFFF 100%);
  border-radius: 6px 6px 0px 0px;
  font-size: 14px;
}
.van-section__footer{
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 10%;
  .footer-btn{
    font-size: 15px;
    text-align: center;
    color: #427afa;
    padding: 16px;
  }
}
.van-section__body {
  padding: 12px 12px;
}

.van-section__title {
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 12px;
}

.list-group {
  >li {
    display: flex;
    align-items: center;
    gap: 16px;
    color: #868A93;
    font-size: 14px;
    padding: 5px 0;
  }
}

.log-content {
  padding: 16px;
  max-height: 60vh;
  overflow-y: auto;
}</style>